export default "__VITE_ASSET__BtH8U25b__"